import { z } from 'zod';

/** Retrato da compra paga por terceiro. O credor é a contraparte da obrigação; não é um usuário. */
export const reimbursementSchema = z
  .object({
    supplierName: z.string().trim().min(2).max(160),
    purchasedOn: z.iso.date(),
    purchaseMethod: z.enum(['PERSONAL_CARD', 'PIX', 'CASH', 'TRANSFER', 'OTHER']),
  })
  .strict();
export type Reimbursement = z.infer<typeof reimbursementSchema>;
export const reimbursementMethodLabels: Record<Reimbursement['purchaseMethod'], string> = {
  PERSONAL_CARD: 'Cartão pessoal',
  PIX: 'Pix pessoal',
  CASH: 'Dinheiro pessoal',
  TRANSFER: 'Transferência pessoal',
  OTHER: 'Outro meio pessoal',
};
